<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="menu-container">
  <div class="row menu-row-container">
    <div class="col-sm-6 gridName-container" style="margin-bottom: 5px;">
      <span class="gridName">Search Organization</span>
    </div>
  </div>
</div>
<div class="table-container">
  <div id="header-container" class="row" style="height: auto;">
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-2"><label>Organization Name</label></div>
        <div class="col-md-6">
          <input type="text" class="input-filed-continers" [(ngModel)]="searchedOrgName">
        </div>
        <div class="col-sm-1 "
          style="padding-left: 6%; margin-top: 1.5%; font-size: 18px; color: black; cursor: pointer;margin-left:-4%">
          <i class="fa fa-search" (click)="searchOrgsFunc()"></i>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="button-continer" mat-dialog-actions class="btn-align" style="display: block;">
          <button mat-stroked-button class="addButton" (click)="searchOrgWithCondition()" style="margin-right:1%;">
            <i class="fa fa-search"></i> Search
          </button>
          <button mat-stroked-button class="cancelButton" (click)="resetData()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<br>
<div class="table-container" *ngIf="isShowTabPages">
  <div class="tab">
    <mat-tab-group selectedIndex="0" mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4"
      animationDuration="0ms" (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex">
      <mat-tab label="Organization">
        <ng-template mat-tab-label>
          <span>Organization</span>
        </ng-template>
        <div class="row">
          <div class="form-body">

            <div class="row" id="scrollToMinPassword" (click)="scrollToMinPassword">
              <div class="col-md-3">
                <div><label for="email">Organization Short Name</label></div>
                <input class="input-filed-continers" name="orgShortName" type="text"
                  [(ngModel)]="organizationData.orgShortName">
              </div>
              <div class="col-md-9">
                <div><label for="email">Organization Full Name</label></div>
                <input class="input-filed-continers" name="orgLongName" type="text"
                  [(ngModel)]="organizationData.orgLongName">
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div><label for="email">Application Display Name</label></div>
                <input class="input-filed-continers" name="applicationName" type="text"
                  [(ngModel)]="organizationData.applicationName">
              </div>
              <div class="col-md-3">
                <div><label for="email">Application URL</label></div>
                <input class="input-filed-continers" name="applicationUrl" type="text"
                  [(ngModel)]="organizationData.applicationUrl">
              </div>
              <div class="col-md-3">
                <div><label for="email">Current Version</label></div>
                <input class="input-filed-continers" name="currentVersion" type="text"
                  [(ngModel)]="organizationData.currentVersion" disabled>
              </div>
              <div class="col-md-3">
                <div><label for="email">Version Upgraded On</label></div>
                <input class="form-control data-picker-continer" name="versionUpgradedOn" bsDatepicker
                  [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="organizationData.versionUpgradedOn" [disabled]="true">
              </div>
              <div class="col-md-3">
                <div><label for="email">User Session Timeout <span class="ancillary-label">(In
                      Mins)</span></label></div>
                <input class="input-filed-continers" type="number" name="userSessionTimeoutInMins" min="1" max="60"
                  (input)="onTimeoutInput($event)" (keydown)="validateNumberFields($event)"
                  [(ngModel)]="organizationData.userSessionTimeoutInMins">

              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div><label for="email">Minimum Username Length</label></div>
                <input class="input-filed-continers" name="minimumUsernameLength" type="number"
                  (keydown)="validateNumberFields($event)" [(ngModel)]="organizationData.minimumUsernameLength">
              </div>
              <div class="col-md-3">
                <div><label for="email">Minimum Password Length</label></div>
                <input id="minimumPasswordLength" class="input-filed-continers" name="c" type="number" min="8"
                  (keydown)="validateNumberFields($event)" [(ngModel)]="organizationData.minimumPasswordLength">
                <span id="minimumpassword-invalid-msg">The minimum required password length is 8
                  characters</span>
              </div>
              <div class="col-md-3">
                <div><label for="email">User Password Expiry <span class="ancillary-label">(In
                      Days)</span></label></div>
                <input class="input-filed-continers" name="userPwdExpiry" type="number"
                  (keydown)="validateNumberFields($event)" [(ngModel)]="organizationData.userPwdExpiry">
              </div>
              <div class="col-md-3">
                <div><label for="email">Reuse Password Cycle <span class="ancillary-label">(In
                      Days)</span></label></div>
                <input class="input-filed-continers" name="reusePwdCycle" type="number"
                  (keydown)="validateNumberFields($event)" [(ngModel)]="organizationData.reusePwdCycle">
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div><label for="email">Allowed Failed Login Attempts</label></div>
                <input class="input-filed-continers" name="loginAttempts" type="number"
                  (keydown)="validateNumberFields($event)" [(ngModel)]="organizationData.loginAttempts">
              </div>
              <div class="col-md-6">
                <div><label for="email">Email Domain</label></div>
                <input class="input-filed-continers" name="emailDomains" type="text"
                  [(ngModel)]="organizationData.emailDomains">
              </div>
              <div class="col-md-3">
                <div><label for="email">Allow Multiple Users to Use Same Email?</label></div>
                <mat-slide-toggle color="primary" name="sameEmailToMultipleUsers"
                  [(ngModel)]="organizationData.sameEmailToMultipleUsers">
                  <ng-container *ngIf="organizationData.sameEmailToMultipleUsers; else noActive">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noActive>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div><label for="email">Reports Timezone</label></div>
                  <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="selectedTimeZone"
                    [settings]="singleSelectDropdownSetting" [data]="timeZoneListDropdown">
                  </ng-multiselect-dropdown>
                </div>
                <div class="col-md-3">
                  <div><label for="email">Is Active?</label></div>
                  <mat-slide-toggle color="primary" name="isActive" [(ngModel)]="organizationData.isActive"
                    (ngModelChange)="checkInactiveFunc(organizationData.isActive)">
                    <ng-container *ngIf="organizationData.isActive; else noActive">
                      <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #noActive>
                      <span style="color: red;">No</span>
                    </ng-template>
                  </mat-slide-toggle>
                </div>
                <div class="col-md-3">
                  <div><label for="email">Stop Emails?</label></div>
                  <mat-slide-toggle color="primary" name="stopEmails" [(ngModel)]="organizationData.stopEmails">
                    <ng-container *ngIf="organizationData.stopEmails; else noStopEmails">
                      <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #noStopEmails>
                      <span style="color: red;">No</span>
                    </ng-template>
                  </mat-slide-toggle>
                </div>
                <div class="col-md-3">
                  <div><label for="email">User Name Format At Application</label></div>
                  <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="selectedNameFormatAtApp"
                    [settings]="singleSelectDropdownSetting" [data]="dropDownForNameFormat">
                  </ng-multiselect-dropdown>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div><label for="email">User Name Format At Reports</label></div>
                  <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="selectedNameFormatAtRep"
                    [settings]="singleSelectDropdownSetting" [data]="dropDownForNameFormat">
                  </ng-multiselect-dropdown>
                </div>
                <div class="col-md-3">
                  <div><label for="email">Date Format</label></div>
                  <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="selectedDateFormat"
                    [settings]="singleSelectDropdownSetting" [data]="dropDownForDateFormat">
                  </ng-multiselect-dropdown>
                </div>
                <div class="col-md-3">
                  <div><label for="email">Allowed File Extns</label>

                  </div>
                  <input class="input-filed-continers" name="emailDomains" type="text"
                    [(ngModel)]="organizationData.allowedFileExtns">
                </div>
                <div class="col-md-3">
                  <div>
                    <label for="email">Allowed File Size(In MB)
                      <span class="ancillary-label" *ngIf="organizationData.allowedFileSizeInMb">
                        {{ formatBytes(organizationData.allowedFileSizeInMb) }} bytes
                      </span>
                    </label>
                  </div>
                  <input class="input-filed-continers" name="allowedFileSize" type="number"
                    [(ngModel)]="organizationData.allowedFileSizeInMb" min="5" max="5120"
                    (keydown)="validateNumberFields($event)" (input)="onSizeInput($event)">
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div><label for="email">Override User Session</label></div>
                  <mat-slide-toggle color="primary" name="stopEmails"
                    [(ngModel)]="organizationData.allowUserInParallelSession">
                    <ng-container *ngIf="organizationData.allowUserInParallelSession; else noParallelSession">
                      <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #noParallelSession>
                      <span style="color: red;">No</span>
                    </ng-template>
                  </mat-slide-toggle>
                </div>
                <div class="col-md-3">
                  <div><label for="email">Organization</label></div>
                  <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="selectedOrgCountries"
                    [settings]="multipleSelectDropdownSetting" [data]="orgCountriesDropdown">
                  </ng-multiselect-dropdown>
                </div>
                <!-- <div class="col-md-3">
                                    <div><label for="email">Stop Emails?</label></div>
                                    <mat-slide-toggle color="primary" name="stopEmails"
                                        [(ngModel)]="organizationData.stopEmails">
                                        <ng-container *ngIf="organizationData.stopEmails; else noStopEmails">
                                            <span class="active-inActive-container"
                                                style="color: rgb(43, 227, 43);">Yes</span>
                                        </ng-container>
                                        <ng-template #noStopEmails>
                                            <span style="color: red;">No</span>
                                        </ng-template>
                                    </mat-slide-toggle>
                                </div> -->
                <div class="col-md-3">
                  <div><label for="email">Hide User Name?</label></div>
                  <mat-slide-toggle color="primary" name="stopEmails" [(ngModel)]="organizationData.hideUserName">
                    <ng-container *ngIf="organizationData.hideUserName; else hideUserName">
                      <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #hideUserName>
                      <span style="color: red;">No</span>
                    </ng-template>
                  </mat-slide-toggle>
                </div>
                <div class="col-md-3">
                  <div><label for="email">Allow Mobile/Tablet Access?</label></div>
                  <mat-slide-toggle color="primary" name="stopEmails"
                    [(ngModel)]="organizationData.isAllowMobileAccess">
                    <ng-container *ngIf="organizationData.isAllowMobileAccess; else isAllowMobileAccess">
                      <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #isAllowMobileAccess>
                      <span style="color: red;">No</span>
                    </ng-template>
                  </mat-slide-toggle>
                </div>
                <div class="col-md-3">
                  <div><label for="email">Re-Use Destructed Doc No/Name?</label></div>
                  <mat-slide-toggle color="primary" name="stopEmails"
                    [(ngModel)]="organizationData.isReuseDestructedDocNameAndNo">
                    <ng-container *ngIf="organizationData.isReuseDestructedDocNameAndNo; else no">
                      <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #no>
                      <span style="color: red;">No</span>
                    </ng-template>
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
            <br>
            <div class="row" *ngIf="isShowInactiveReason">
              <div class="col-md-6">
                <div><label for="email">Inactive Reason</label><span class="mandatory-symbol">*</span>
                </div>
                <textarea id="inactiveReason" type="text" name="updateReason" class="input-filed-textarea" rows="6"
                  cols="50" [(ngModel)]="organizationData.inactiveReason" (focusout)="onFieldFocusout()"
                  style="width: 100% !important;"></textarea>
                <span id="inactiveReason-required-msg">Please provide the reason for inactive</span>
              </div>
            </div>
            <br>

            <div class="menu-container">
              <div class="row menu-row-container">
                <div class="col-sm-6 gridName-container">
                  <span class="gridName">License Terms</span>
                </div>
              </div>
            </div>

            <br>
            <!--  <div class="col-md-2">
                                <div>
                                    <label id="date-reported-validation" for="email">Date Reported</label>
                                    <span class="mandatory-symbol">*</span>
                                </div>
                                <input type="text" class="form-control data-picker-continer" bsDatepicker
                                    [bsConfig]="reportedDateConfig()" [dateCustomClasses]="dateCustomClasses"
                                    [(ngModel)]="qmsservice.activity.dateReported"
                                    (ngModelChange)="onNgModelChange($event, 'date-reported-validation')"
                                    [disabled]="!qmsservice.activity.dateOfOccurrence || isDateSectionFrozen">
                            </div> -->
            <div class="row">
              <div class="col-md-3">
                <div><label for="email">Started On</label></div>
                <input class="form-control data-picker-continer" name="licenseStartedOn" bsDatepicker
                  [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="organizationData.licenseStartedOn"
                  (ngModelChange)="setVal(organizationData.licenseStartedOn)">
              </div>
              <div class="col-md-3">
                <div><label for="email">Renewed On</label></div>
                <input class="form-control data-picker-continer" name="licenseRenewedOn" bsDatepicker
                  [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                  [minDate]="minRenewedDate" [(ngModel)]="organizationData.licenseRenewedOn "
                  (ngModelChange)="setVal(organizationData.licenseRenewedOn)">
              </div>
              <div class="col-md-3">
                <div><label for="email">Expiry Date</label></div>
                <input id="licenseExpiryDate" class="form-control data-picker-continer" name="licenseExpiryDate"
                  bsDatepicker [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                  [minDate]="minExpiryDate" [(ngModel)]="organizationData.licenseExpiryDate">
              </div>
              <div class="col-md-3">
                <div><label for="email">Warning Period <span class="ancillary-label">(In
                      Days)</span></label></div>
                <input class="form-control" name="licenseWarningPeriodInDays" type="text"
                  [(ngModel)]="organizationData.licenseWarningPeriodInDays">
              </div>
            </div>
            <br>
            <div class="menu-container">
              <div class="row menu-row-container">
                <div class="col-sm-6 gridName-container">
                  <span class="gridName">AD Settings</span>
                </div>
              </div>
            </div>

            <br>
            <div class="row">
              <div class="col-md-2">
                <div><label for="email">AD Enabled?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationData.adEnabled"
                  (change)="onCheckboxChange($event)">
                  <ng-container *ngIf="organizationData.adEnabled; else noAdEnabled">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noAdEnabled>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-4" *ngIf="organizationData.adEnabled">
                <div><label for="email">AD Type</label></div>
                <ng-multiselect-dropdown id="owner" class="multiselect-container" [(ngModel)]="selectedADType"
                  [settings]="singleSelectDropdownSetting" [data]="adListDropdown">
                </ng-multiselect-dropdown>
              </div>
              <div class="col-md-3" *ngIf="organizationData.adEnabled">
                <div><label for="email">Tenant ID</label></div>
                <input class="input-filed-continers" name="talentId" type="text"
                  [(ngModel)]="organizationData.talentId">
              </div>
              <div class="col-md-3" *ngIf="organizationData.adEnabled">
                <div><label for="email">Client ID</label></div>
                <input class="input-filed-continers" name="clientId" type="text"
                  [(ngModel)]="organizationData.clientId">
              </div>
            </div>

            <br>
            <div class="row" *ngIf="organizationData.adEnabled">
              <div class="col-md-3">
                <div><label for="email">Authentication Forced At Login</label></div>
                <mat-slide-toggle color="primary" name="noAuthLogin"
                  [(ngModel)]="organizationData.isAdAuthenticationForcedAtLogin">
                  <ng-container *ngIf="organizationData.isAdAuthenticationForcedAtLogin; else noAuthLogin">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noAuthLogin>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-3">
                <div><label for="email">Authentication Forced At Approvals</label></div>
                <mat-slide-toggle color="primary" name="noAuthApproval"
                  [(ngModel)]="organizationData.isAdAuthenticationForcedAtApprovals">
                  <ng-container *ngIf="organizationData.isAdAuthenticationForcedAtApprovals; else noAuthApproval">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noAuthApproval>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
            </div>
            <br *ngIf="organizationData.adEnabled">
            <div class="row">
              <div class="col-md-6">
                <div><label for="email">Reason for Update</label><span class="mandatory-symbol">*</span>
                </div>
                <textarea id="updateReason" type="text" name="updateReason" class="input-filed-textarea" rows="6"
                  cols="50" [(ngModel)]="organizationData.updateReason" (focusout)="onFieldFocusout()"
                  style="width: 100% !important;"></textarea>
                <span id="updateReason-required-msg">Please provide the reason for update</span>
              </div>
            </div>

            <br>
            <div class="button-continer" mat-dialog-actions class="btn-align">
              <button style="margin-left: 1%;" mat-stroked-button class="addButton"
                (click)="updateOneQmsOrganization(organizationData)">
                <i class="fas fa-user-edit"></i> Update
              </button>
            </div>
          </div>

        </div>
      </mat-tab>
      <mat-tab label="Organization Privileges">
        <ng-template mat-tab-label>
          <span>Organization Privileges</span>
        </ng-template>
        <div class="row">
          <div class="form-body">
            <div class="menu-container">
              <div class="row menu-row-container">
                <div class="col-sm-6 gridName-container">
                  <span class="gridName">License Modules</span>
                </div>
              </div>
            </div>

            <br>
            <div class="row">
              <div class="col-md-2">
                <div><label for="email">Quality?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="quality"
                  (change)="changeInModule(quality)">
                  <ng-container *ngIf="quality; else noQuality">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noQuality>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2">
                <div><label for="email">Trainings?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.trn">
                  <ng-container *ngIf="organizationPrivelegesData.trn; else noTrn">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noTrn>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2">
                <div><label for="email">Documents?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.docs">
                  <ng-container *ngIf="organizationPrivelegesData.docs; else noDocs">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noDocs>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2">
                <div><label for="email">Forms and Logs?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled"
                  [(ngModel)]="organizationPrivelegesData.formsAndLogs">
                  <ng-container *ngIf="organizationPrivelegesData.formsAndLogs; else noFormsAndLogs">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noFormsAndLogs>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2">
                <div>
                  <label id="topic" for="email">Topic No. of Days At Home</label>
                  <span class="mandatory-symbol">*</span>
                </div>
                <input class="input-filed-continers" name="loginAttempts" type="number"
                  (keydown)="validateNumberFields($event)" (ngModelChange)="onNgModelChange($event,'topic')"
                  [(ngModel)]="organizationPrivelegesData.topicNoOfDaysAtHome">
              </div>
              <div class="col-md-2">
                <div><label for="email">Business Process?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.bp">
                  <ng-container *ngIf="organizationPrivelegesData.bp; else nobp">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #nobp>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
            </div>

            <br>
            <div class="menu-container">
              <div class="row menu-row-container">
                <div class="col-sm-6 gridName-container">
                  <span class="gridName">Modules / User Limits</span>
                </div>
              </div>
            </div>

            <br>
            <div class="row" *ngIf="quality">
              <div class="col-md-2">
                <div><label for="email">Change Request?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.cr">
                  <ng-container *ngIf="organizationPrivelegesData.cr; else noCr">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noCr>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2">
                <div><label for="email">CAPA?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.capa">
                  <ng-container *ngIf="organizationPrivelegesData.capa; else noCapa">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noCapa>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2">
                <div><label for="email">Deviation?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.dv">
                  <ng-container *ngIf="organizationPrivelegesData.dv; else noDv">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noDv>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2">
                <div><label for="email">Audit?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.au">
                  <ng-container *ngIf="organizationPrivelegesData.au; else noAu">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noAu>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2">
                <div><label for="email">Incident?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.in">
                  <ng-container *ngIf="organizationPrivelegesData.in; else noIn">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noIn>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2">
                <div><label for="email">Quality Issue?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.qi">
                  <ng-container *ngIf="organizationPrivelegesData.qi; else noQi">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noQi>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2" *ngIf="quality">
                <div><label for="email">Customer Complaint?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.cc">
                  <ng-container *ngIf="organizationPrivelegesData.cc; else noCc">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #noCc>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2" *ngIf="quality">
                <div><label for="email">Out of Specification?</label></div>
                <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivelegesData.oos">
                  <ng-container *ngIf="organizationPrivelegesData.oos; else nooos">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #nooos>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
            </div>

            <br *ngIf="quality">
            <div class="row">
              <!-- <div class="col-md-5 d-flex"> -->
              <div class="col-md-3 p-1" *ngIf="quality">
                <div><label for="email">Quality Task Count</label></div>
                <input class="input-filed-continers" name="licenseStartedOn" type="text"
                  [(ngModel)]="organizationPrivelegesData.qualityTaskCount">
              </div>
              <div class="col-md-3 p-1" *ngIf="quality">
                <div><label for="email">Quality User Count</label></div>
                <input class="input-filed-continers" name="licenseStartedOn" type="text"
                  [(ngModel)]="organizationPrivelegesData.qualityUserCount">
              </div>
              <div class="col-md-3 p-1" *ngIf="organizationPrivelegesData.trn">
                <div><label for="email">Training User Count</label></div>
                <input class="input-filed-continers" name="licenseStartedOn" type="text"
                  [(ngModel)]="organizationPrivelegesData.trnUserCount">
              </div>

              <!-- <div class="col-md-5 d-flex"> -->
              <div class="col-md-3 p-1" *ngIf="organizationPrivelegesData.docs">
                <div><label for="email">Document User Count</label></div>
                <input class="input-filed-continers" name="licenseStartedOn" type="text"
                  [(ngModel)]="organizationPrivelegesData.docsUserCount">
              </div>
              <div class="col-md-3 p-1">
                <div><label for="email">Concurrent User Count</label></div>
                <input class="input-filed-continers" name="licenseStartedOn" type="text"
                  [(ngModel)]="organizationPrivelegesData.concurrentUserCount">
              </div>
              <div class="col-md-3 p-1" *ngIf="organizationPrivelegesData.formsAndLogs">
                <div><label for="email">Forms and Logs Count</label></div>
                <input class="input-filed-continers" name="licenseStartedOn" type="text"
                  [(ngModel)]="organizationPrivelegesData.formsAndLogsCount">
              </div>


              <div class="col-md-3 p-1" *ngIf="organizationPrivelegesData.bp">
                <div><label for="email">Business Process Count</label></div>
                <input class="input-filed-continers" name="licenseStartedOn" type="text"
                  [(ngModel)]="organizationPrivelegesData.bpSetupCount">
              </div>

            </div>

            <br>
            <div class="row">
              <div class="col-md-6">
                <div><label for="email">Reason for Update</label><span class="mandatory-symbol">*</span>
                </div>
                <textarea id="updateReason1" type="text" name="updateReason" class="input-filed-textarea" rows="6"
                  cols="50" [(ngModel)]="organizationPrivelegesData.updateReason" (focusout)="onFieldFocusout()"
                  style="width: 100% !important;"></textarea>
                <span id="updateReason1-required-msg">Please provide the reason for update</span>
              </div>
            </div>

            <br>
            <div class="button-continer" mat-dialog-actions class="btn-align">
              <button style="margin-left: 1%;" mat-stroked-button class="addButton"
                (click)="updateOneQmsOrganizationPriv(organizationPrivelegesData)">
                <i class="fas fa-user-edit"></i> Update
              </button>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<ng-template #SearchOrgpopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSearchOrgPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <!-- <h2 mat-dialog-title class="close-button">ONE-<span style="color:gold;">QMS</span></h2> -->

    <div mat-dialog-title>
      <label for="title" class="popupTitle">Organizations</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 10px;">
      <div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-container">
              <div id="header-container" class="row">
                <div class="col-md-4">
                  <div class="row-search-container">

                    <input type="text" class="form-control" style="font-size: 13px;" placeholder="Search"
                      [(ngModel)]="searchValue1">
                  </div>
                </div>
                <div class="col-8 col-md-6pr-0 d-flex  justify-content-end align-items-center">

                  {{ showingRowsText }}
                  1-{{ perPage }} of {{ collectionSize | number }}
                  <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)"
                    [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                    [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true"
                    size="sm">
                  </ngb-pagination>
                  <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic1" ngbDropdownToggle>
                      {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                      <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
                      <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
                    </div>
                    per page
                  </div>
                </div>
              </div>
              <table class="dynamic-table-container">
                <th></th>
                <th style="min-width: 80px;max-width: 80px;"> <span>Org ID</span> <span
                    class="fa-solid fa-filter"></span> </th>
                <th> <span>Org Short Name</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>Org Long Name</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>Current Version</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>Is Active?</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>License Started On</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>License Renewed On</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>License Expiry Date</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>Created On</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>Updated On</span> <span class="fa-solid fa-filter"></span> </th>

                <th id="menu" class="sticky-col first-col"></th>
                <tr class="data-row-container"
                  *ngFor="let org of pagedItems1 | searchFilter : searchValue1; let idx = index;">
                  <td style="width: 60px; text-align: center;"
                    [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                    <div style="display: flex;">
                      <div [ngClass]="org.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                      </div>
                      <div>
                        <input type="checkbox" style="zoom: 1.2;" [checked]="org.childCheckBoxs"
                          (change)="dataGridChildCheckBoxChecked($event, org, idx)">
                      </div>
                    </div>
                  </td>
                  <td class="row-data" style="min-width: 80px;max-width: 80px;"><span>{{ org.orgId
                      }}</span></td>
                  <td class="row-data">{{org.orgShortName}}</td>
                  <td class="row-data">{{ org.orgLongName}}</td>
                  <td class="row-data">{{ org.currentVersion}}</td>
                  <td>
                    <div class="gridCheckBoxes">
                      <img *ngIf="org.isActive == 'Y'" src="../../../assets/img/accessSymbol.svg" width="20"
                        height="20">
                      <img *ngIf="org.isActive == 'N'" src="../../../assets/img/noAcessSymbol.svg" width="20"
                        height="20">
                    </div>
                  </td>
                  <td class="row-data">{{ org.licenseStartedOn |
                    date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
                  </td>
                  <td class="row-data">{{ org.licenseRenewedOn |
                    date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
                  </td>
                  <td class="row-data">{{ org.licenseExpiryDate |
                    date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
                  </td>
                  <td class="row-data">{{ org.createdOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
                  <td class="row-data">{{ org.updatedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
                </tr>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="addSearchedOrg()">
        <i class="fas fa-plus"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelSearchOrgPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>